import { IconPlugConnected } from "@tabler/icons-react";
import { queryOptions } from "@/Services";
import { FilterSelect } from "./FilterSelect";
import { useTranslation } from "react-i18next";
import classes from "./FilterSelect.module.css";

export const IntegrationFilterSelect = ({ onChange, ...props }) => {
    const { t } = useTranslation();
    const { data: integrations, isLoading } = queryOptions({ type: 'integration' });

    return (
        <FilterSelect
            placeholder={t('ads.integration')}
            w={160}
            searchable
            nothingFoundMessage={t('ads.noIntegrationFound')}
            leftSection={(
                <svg className={classes.icon} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M10 4.33333C10 4.77536 10.1756 5.19928 10.4882 5.51184C10.8007 5.8244 11.2246 6 11.6667 6C12.1087 6 12.5326 5.8244 12.8452 5.51184C13.1577 5.19928 13.3333 4.77536 13.3333 4.33333C13.3333 3.89131 13.1577 3.46738 12.8452 3.15482C12.5326 2.84226 12.1087 2.66667 11.6667 2.66667C11.2246 2.66667 10.8007 2.84226 10.4882 3.15482C10.1756 3.46738 10 3.89131 10 4.33333Z" stroke="#212529" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M3.15482 12.8452C2.84226 12.5326 2.66667 12.1087 2.66667 11.6667C2.66667 11.2246 2.84226 10.8007 3.15482 10.4882C3.46738 10.1756 3.89131 10 4.33333 10C4.77536 10 5.19929 10.1756 5.51185 10.4882C5.82441 10.8007 6 11.2246 6 11.6667C6 12.1087 5.82441 12.5326 5.51185 12.8452C5.19929 13.1577 4.77536 13.3333 4.33333 13.3333C3.89131 13.3333 3.46738 13.1577 3.15482 12.8452Z" stroke="#212529" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M5.66667 10.3333L10.3333 5.66667" stroke="#212529" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
            )}
            data={integrations || []}
            disabled={isLoading}
            onChange={onChange}
            {...props}
        />
    );
};
